import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { PrivatePageLayout, PageHeader, PageTableCard } from '../../components/PrivatePage';
import SearchSymbol from '../../components/SearchSymbol/SearchSymbol';
import NewOrderButton from '../../components/NewOrder/NewOrderButton';
import NewOrderModal from '../../components/NewOrder/NewOrderModal';
import OrderRow from './OrderRow';
import { getOrders } from '../../services/OrdersService';
import Pagination from '../../components/Pagination/Pagination';
import ViewOrderModal from './ViewOrderModal';
import Toast from '../../components/Toast/Toast';
import PositionsTable from '../Futures/PositionsTable';
import SpotFuturesToggle from '../../components/SpotFuturesToggle/SpotFuturesToggle';

function Orders() {

    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    const history = useHistory();

    useEffect(() => {
        return history.listen((location) => {
            setPage(getPage(location));
        })
    }, [history])

    const { symbol } = useParams();

    const [search, setSearch] = useState(symbol ? symbol : '');

    const [orders, setOrders] = useState([]);

    const [notification, setNotification] = useState([]);

    const [count, setCount] = useState(0);

    const [viewOrder, setViewOrder] = useState({});

    const [page, setPage] = useState(getPage());

    const [isLoading, setIsLoading] = useState(false);

    const [refresh, setRefresh] = useState(0);

    const [showSpot, setShowSpot] = useState(true); // Show spot data
    const [showFutures, setShowFutures] = useState(false); // Show futures data

    useEffect(() => {
        setIsLoading(true);
        getOrders(search, page || 1, showFutures)
            .then(result => {
                setOrders(result.rows);
                setCount(result.count);
                setViewOrder(result.rows[0]);
                setIsLoading(false);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
                setIsLoading(false);
            })

    }, [search, page, refresh, showFutures])

    function onSearchChange(event) {
        setSearch(event.target.value);
    }

    function onViewClick(event) {
        const id = event.target.id.replace('view', '');
        const order = orders.find(o => o.id == id);
        setViewOrder({ ...order });
    }

    function onOrderSubmit(order) {
        setRefresh(Date.now());
    }

    useEffect(() => {
        if (showSpot) {
            history.push('/orders/');
        } else {
            history.push('/forders/');
        }
    }, [showSpot, history])

    const headerActions = (
        <>
            {localStorage.getItem("hasFutures") === "true" ? (
                <SpotFuturesToggle
                    value={showFutures ? 'futures' : 'spot'}
                    onChange={(market) => {
                        setShowSpot(market === 'spot');
                        setShowFutures(market === 'futures');
                    }}
                />
            ) : null}
            <NewOrderButton />
            <SearchSymbol onChange={onSearchChange} placeholder={search} />
        </>
    );

    return (
        <React.Fragment>
            <PrivatePageLayout>
                <PageHeader
                    eyebrow="Trading"
                    title={`${showFutures ? 'Futures' : 'Spot'} orders`}
                    subtitle="View open and recent orders from your connected exchange."
                    actions={headerActions}
                />
                <PageTableCard>
                    <div className="table-wrapper table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="border-gray-200">Order</th>
                                    <th className="border-gray-200">Date</th>
                                    <th className="border-gray-200">Qty</th>
                                    <th className="border-gray-200">Net</th>
                                    <th className="border-gray-200">Status</th>
                                    <th className="border-gray-200">View</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading && orders && orders.length
                                    ? orders.map((order) => (<OrderRow key={order.clientOrderId} data={order} onClick={onViewClick} />))
                                    : <tr><td colSpan={6}>Loading...</td></tr>}
                            </tbody>
                        </table>
                    </div>
                    <Pagination count={count} />
                </PageTableCard>
                {showFutures ? <PositionsTable /> : null}
            </PrivatePageLayout>
            <ViewOrderModal data={viewOrder} onUpdate={onOrderSubmit} />
            <NewOrderModal onSubmit={onOrderSubmit} />
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default Orders;
